import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaFacebook, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import FooterListTitle from "./FooterListTitle";

const Footer = () => {
  const [emailInfo, setEmailInfo] = useState("");
  const [subscription, setSubscription] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const emailValidation = () => {
    return String(emailInfo)
      .toLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSubscription = () => {
    if (emailInfo === "") {
      setErrMsg("Please provide an Email!");
    } else if (!emailValidation(emailInfo)) {
      setErrMsg("Please enter a valid Email!");
    } else {
      setSubscription(true);
      setErrMsg("");
      setEmailInfo("");
    }
  };

  return (
    <div className="w-full bg-[#F5F5F3] pt-16 pb-8">
      <div className="max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 px-4 gap-10">

        {/* Brand Column */}
        <div className="col-span-2">
          <FooterListTitle title="LD Leo Life" />
          <div className="flex flex-col gap-4">
            <p className="text-sm text-gray-600 leading-relaxed xl:w-[85%]">
              Your One-Stop Home Care Destination! Discover the magic of a
              sparkling clean home with our premium range of products — from
              kitchenware to cleaning supplies, we have every corner covered.
            </p>

            {/* Contact Details */}
            <div className="flex flex-col gap-2 text-sm text-gray-600">
              <div className="flex items-start gap-2">
                <FaMapMarkerAlt className="text-primeColor mt-0.5 flex-shrink-0" />
                <span>No. 14, Circular Road, Hatton, Sri Lanka.</span>
              </div>
              <div className="flex items-center gap-2">
                <FaPhoneAlt className="text-primeColor flex-shrink-0" />
                <span>077 346 2913 &nbsp;|&nbsp; 051 222 5770</span>
              </div>
              <div className="flex items-center gap-2">
                <FaEnvelope className="text-primeColor flex-shrink-0" />
                <a href="mailto:ldleolife@gmail.com" className="hover:text-primeColor transition-colors">
                  ldleolife@gmail.com
                </a>
              </div>
            </div>

            {/* Social Icons */}
            <ul className="flex items-center gap-2 mt-1">
              <a href="https://www.facebook.com/LDLeoLife/" target="_blank" rel="noreferrer">
                <li className="w-8 h-8 bg-primeColor text-white cursor-pointer text-base rounded-full flex justify-center items-center hover:bg-blue-600 duration-300">
                  <FaFacebook />
                </li>
              </a>
              <a href="https://wa.me/94773462913" target="_blank" rel="noreferrer">
                <li className="w-8 h-8 bg-primeColor text-white cursor-pointer text-base rounded-full flex justify-center items-center hover:bg-green-500 duration-300">
                  <FaWhatsapp />
                </li>
              </a>
            </ul>
          </div>
        </div>

        {/* Shop Categories */}
        <div>
          <FooterListTitle title="Shop" />
          <ul className="flex flex-col gap-2">
            {["Home Care", "Personal Care", "Kitchen Care", "Cleaning Supplies", "Gift Items"].map((item) => (
              <li key={item}>
                <Link
                  to="/shop"
                  className="font-titleFont text-sm text-lightText hover:text-black hover:underline decoration-[1px] decoration-gray-500 underline-offset-2 cursor-pointer duration-300"
                >
                  {item}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <FooterListTitle title="Quick Links" />
          <ul className="flex flex-col gap-2">
            {[
              { label: "About Us", to: "/about", state: { data: "Footer" } },
              { label: "Contact", to: "/contact", state: { data: "Footer" } },
              { label: "My Cart", to: "/cart" },
              { label: "Shop", to: "/shop" },
            ].map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  state={item.state}
                  className="font-titleFont text-sm text-lightText hover:text-black hover:underline decoration-[1px] decoration-gray-500 underline-offset-2 cursor-pointer duration-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter */}
        <div className="col-span-2 flex flex-col w-full px-0">
          <FooterListTitle title="Stay Updated" />
          <p className="text-sm text-gray-500 mb-4">
            Subscribe for exclusive deals, new arrivals, and home care tips directly
            to your inbox.
          </p>
          {subscription ? (
            <motion.p
              initial={{ x: 20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="w-full text-sm font-semibold text-green-600"
            >
              🎉 Subscribed successfully! Thank you.
            </motion.p>
          ) : (
            <div className="flex flex-col gap-2">
              <div className="flex w-full border border-gray-300 rounded-md overflow-hidden">
                <input
                  onChange={(e) => setEmailInfo(e.target.value)}
                  value={emailInfo}
                  className="flex-1 h-11 px-4 text-sm text-primeColor outline-none bg-white"
                  type="email"
                  placeholder="Your email address..."
                />
                <button
                  onClick={handleSubscription}
                  className="bg-primeColor text-white px-5 text-sm font-semibold hover:bg-black duration-300 whitespace-nowrap"
                >
                  Subscribe
                </button>
              </div>
              {errMsg && (
                <p className="text-red-500 text-xs font-medium">{errMsg}</p>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-container mx-auto px-4 mt-10 pt-6 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-2">
        <p className="text-xs text-gray-400">
          © {new Date().getFullYear()} LD Leo Life. All rights reserved. | Hatton, Sri Lanka.
        </p>
        <p className="text-xs text-gray-400">
          "A Clean Home is a Happy Home" ✨
        </p>
      </div>
    </div>
  );
};

export default Footer;
